import { useMemo } from 'react';

export default function useDev() {
  const isDev = useMemo(() => {
    return process.env.NODE_ENV === 'development';
  }, []);

  return isDev;
}
